<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">500</h1>
          <h4 class="pt-3">Houston, we have a problem!</h4>
          <p class="text-muted">Strona jest tymczasowo niedostępna.</p>
        </div>
        <div class="clearfix">
          <p class="text-muted">W przypadku przedłużającej sie przerwy w dostępie proszę o kontakt z administratorem.</p>
        </div>        
      </div>
    </div>
  </div>
</div>
